"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            TaskGuidesStep_RailsSwitchAckButton: "Go back",
            TaskRecorder_SwitchRailsModeOff: "Unlock",
            TaskRecorder_SwitchRailsModeOff_ToolTip: "Turn off task guide execution lock down",
            TaskRecorder_SwitchRailsModeOn: "Lock",
            TaskRecorder_SwitchRailsModeOn_ToolTip: "Turn on task guide execution lock down",
        }
    });
    var controls;
    (function (controls) {
        /** Client implementation of X++ TaskRecorderStepAction control. */
        var TaskRecorderStepAction = /** @class */ (function (_super) {
            __extends(TaskRecorderStepAction, _super);
            function TaskRecorderStepAction(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                _this.icon = $dyn.computed(function () {
                    return { Items: ["1", "Symbol", $dyn.util.stringToBoolean($dyn.value(_this.HasAnnotation)) ? "Comment" : "Edit"] };
                });
                _this.Width = $dyn.layout.Size.available;
                return _this;
            }
            return TaskRecorderStepAction;
        }($dyn.ui.Control));
        controls.TaskRecorderStepAction = TaskRecorderStepAction;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=TaskRecorderStepAction.js.map
